import { Dispatch, useState } from "react";
import styles from "./CommonFields.module.css";
import { Banner, Checkbox, Collapsible, FormLayout, Label, LegacyCard } from "@shopify/polaris";
import { MdOutlineArrowBackIosNew } from "react-icons/md";
import { Field } from "@shopify/react-form";
import {
    Action,
    BxgyConfigInterface,
    FBTConfigInterface,
    MixMatchConfigInterface,
    ProductAddonsConfigInterface,
    StandardConfigInterface,
    VolumeConfigInterface,
} from "../Types";

type Props_GeneralSettings = {
    bundleConfig:
        | StandardConfigInterface
        | VolumeConfigInterface
        | BxgyConfigInterface
        | MixMatchConfigInterface
        | FBTConfigInterface | ProductAddonsConfigInterface;
    dispatchBundleConfig: Dispatch<Action<any>>;
    show_bundle_on_product_page: Field<boolean | undefined>;
    show_multiple_bundles_on_product_page: Field<boolean | undefined>;
};

const GeneralSettings = ({
    bundleConfig,
    dispatchBundleConfig,
    show_bundle_on_product_page,
    show_multiple_bundles_on_product_page,
}: Props_GeneralSettings) => {
    const [expandGeneral, setExpandGeneral] = useState(true);

    return (
        <>
            <div className={styles.sectionTitleWrapper} onClick={() => setExpandGeneral((ps) => !ps)}>
                <div>General Settings</div>

                <div
                    style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        transform: expandGeneral ? "rotate(90deg)" : "rotate(270deg)",
                    }}
                >
                    <MdOutlineArrowBackIosNew size={14} />
                </div>
            </div>
            <Collapsible
                open={expandGeneral}
                id="basic-collapsible"
                transition={{
                    duration: "500ms",
                    timingFunction: "ease-in-out",
                }}
                expandOnPrint
            >
                <FormLayout>
                    <LegacyCard title="">
                        <Banner tone={"warning"}>
                            <div>Changes made to the general settings will apply to all bundles</div>
                        </Banner>
                    </LegacyCard>
                    <div className={`${styles.formRow} ${styles.formCol}`}>
                        <div className={styles.customLabelWrapper} style={{ marginBottom: "5px" }}>
                            <Label id="discount_combinations">Display Widget</Label>
                        </div>

                        <div
                            style={{
                                display: "flex",
                                flexDirection: "column",
                                marginTop: "-10px",
                            }}
                        >
                            <Checkbox
                                label={"Show bundles on product page"}
                                {...show_bundle_on_product_page}
                                value=""
                                checked={show_bundle_on_product_page.value}
                                onChange={(val) => {
                                    dispatchBundleConfig({
                                        payload: {
                                            ...bundleConfig?.general_settings,
                                            show_bundle_on_product_page: val,
                                        },
                                        key: "general_settings",
                                    });
                                    show_bundle_on_product_page.onChange(val);
                                }}
                            />
                            <Checkbox
                                label={"Show multiple bundles on product page"}
                                {...show_multiple_bundles_on_product_page}
                                value=""
                                checked={show_multiple_bundles_on_product_page.value}
                                onChange={(val) => {
                                    dispatchBundleConfig({
                                        payload: {
                                            ...bundleConfig?.general_settings,
                                            show_multiple_bundles_on_product_page: val,
                                        },
                                        key: "general_settings",
                                    });
                                    show_multiple_bundles_on_product_page.onChange(val);
                                }}
                            />
                        </div>
                    </div>
                    {/* <div
                            className={`${styles.formRow} ${styles.row4} ${styles.formCol}`}
                        >
                            <Label id="bundle_product_level">
                                <>Redirect after adding products to cart</>
                            </Label>
                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    marginTop: "-10px",
                                }}
                            >
                                <RadioButton
                                    label={"To checkout"}
                                    id={REDIRECT_OPTIONS.CHECKOUT}
                                    name="redirect_add_to_cart"
                                    {...asChoiceField(
                                        redirect_after_adding_product_to_cart,
                                        "checkout",
                                    )}
                                    onChange={(status, val) => {
                                        dispatchBundleConfig({
                                            payload: {
                                                ...bundleConfig?.general_settings,
                                                redirect_after_adding_product_to_cart:
                                                    val,
                                            },
                                            key: "general_settings",
                                        });
                                        redirect_after_adding_product_to_cart.onChange(
                                            val,
                                        );
                                    }}
                                />
                                <RadioButton
                                    label={"To cart"}
                                    id={REDIRECT_OPTIONS.CART}
                                    name="redirect_add_to_cart"
                                    {...asChoiceField(
                                        redirect_after_adding_product_to_cart,
                                        "cart",
                                    )}
                                    onChange={(status, val) => {
                                        dispatchBundleConfig({
                                            payload: {
                                                ...bundleConfig?.general_settings,
                                                redirect_after_adding_product_to_cart:
                                                    val,
                                            },
                                            key: "general_settings",
                                        });
                                        redirect_after_adding_product_to_cart.onChange(
                                            val,
                                        );
                                    }}
                                />
                                <RadioButton
                                    label={"No redirect"}
                                    id={REDIRECT_OPTIONS.NONE}
                                    name="redirect_add_to_cart"
                                    {...asChoiceField(
                                        redirect_after_adding_product_to_cart,
                                        "none",
                                    )}
                                    onChange={(status, val) => {
                                        dispatchBundleConfig({
                                            payload: {
                                                ...bundleConfig?.general_settings,
                                                redirect_after_adding_product_to_cart:
                                                    val,
                                            },
                                            key: "general_settings",
                                        });
                                        redirect_after_adding_product_to_cart.onChange(
                                            val,
                                        );
                                    }}
                                />
                            </div>
                        </div> */}
                </FormLayout>
            </Collapsible>
        </>
    );
};

export default GeneralSettings;
